<template>
    <div class="ah-qr-code-uploader">
        <div class="img-block">
            <img v-if="qrCodeSrc" :src="qrCodeSrc" :class="{ 'qr-disabled': !restTime }" alt="qr-code" />
            <i v-else class="el-icon-loading"></i>
        </div>
        <!-- <span class="rest-time" v-if="restTime">{{ restTime }}</span> -->
        <el-button v-if="!restTime" type="primary" @click="reset()" size="small">重新取得QR Code</el-button>
        <span style="color: #888; margin-top: 10px;">掃描 <span @click="() => { isUseV2 = !isUseV2; reset(); }">QR Code</span> 使用手機上傳 <span v-if="isUseV2">(v2)</span></span>

    </div>
</template>

<script>
import QRCode from 'qrcode';
import moment from 'moment';

let checkIngInterval;
let updateTimeInterval;
const COUNTDOWN_FROM = 5;

export default {
    name: 'ah-qr-code-uploader',
    props: {
        visible: Boolean,
    },
    data() {
        return {
            key: null,
            mno: null,
            qrCodeDataUrl: null,
            url: null,
            isUseV2: true,
            latestImg: null,
            currentTimeStamp: moment(),
            dueTimeStamp: moment().add(COUNTDOWN_FROM, 'minute'),
        };
    },
    computed: {
        qrCodeSrc() {
            if (this.visible && !this.qrCodeDataUrl) {
                this.getID();
                this.onStartCheck();
            } else if (!this.visible) this.reset();

            return this.qrCodeDataUrl;
        },
        restTime() {
            const DIFF = Number(this.dueTimeStamp.diff(this.currentTimeStamp, 'seconds'));
            const MIN = Math.floor(DIFF / 60) > 0 ? `0${Math.floor(DIFF / 60)}: ` : '';
            const SEC = DIFF % 60 >= 10 ? DIFF % 60 : `0${DIFF % 60}`;
            if (DIFF > 0) return `${MIN}${SEC}`;

            clearInterval(checkIngInterval);
            clearInterval(updateTimeInterval);
            return false;
        },
        companyBsn() {
            return this.$store.getters['menu/companyInfo'].bsn;
        },
    },
    methods: {
        async getID() {
            try {
                const resp = await this.$api({
                    url: '/Tool/GenerateUploadKey',
                    method: 'GET',
                });
                this.key = resp.data.key;
                this.mno = resp.data.mno;

                updateTimeInterval = setInterval(async () => {
                    this.currentTimeStamp = moment();
                }, 1000);

                // eslint-disable-next-line max-len
                let VIEW_URL = `${process.env.VUE_APP_BASE_URL}qr-code-uploader?key=${this.key}&mno=${this.mno}`;

                // 新版掃描工具
                if (this.isUseV2) {
                    VIEW_URL = `https://scan.sokuji.tw/?key=${this.key}&mno=${this.mno}`;
                }

                this.url = VIEW_URL;
                this.qrCodeDataUrl = await QRCode.toDataURL(VIEW_URL);
            } catch (err) {
                console.error(err);
            }
        },

        reset() {
            this.dueTimeStamp = moment().add(COUNTDOWN_FROM, 'minute');
            this.key = null;
            this.mno = null;
            this.qrCodeDataUrl = null;
            this.url = null;
            clearInterval(checkIngInterval);
            clearInterval(updateTimeInterval);
        },
        onStartCheck() {
            checkIngInterval = setInterval(async () => {
                const resp = await this.$api({
                    url: '/Tool/GetExternalUploadedPath',
                    method: 'GET',
                    params: { key: this.key },
                });
                if (resp.data.imags || resp.data.meta) {
                    this.$emit('change', resp.data.imag, JSON.parse(resp.data.meta));
                    clearInterval(checkIngInterval);
                }
            }, 3000);
        },
    },
    destroyed() {
        this.reset();
    },
};
</script>

<style lang="scss" scoped>
.ah-qr-code-uploader {
    display: flex;
    flex-direction: column;
    align-items: center;
    .img-block {
        width: 150px;
        height: 150px;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #ddd;
    }
    img {
        width: 100%;
        height: 100%;
    }
    .qr-disabled {
        opacity: 0.1;
    }
    .rest-time {
        font-size: 7pt;
        font-family: monospace;
        margin: -10px 0 0 0;
    }
}
</style>
